function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classnames from "classnames";
import React, { useEffect } from "react";
import Modal from "react-modal";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import styles from "./generic-modal.css";

function GenericModal(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onAfterOpen = _ref.onAfterOpen,
      onClose = _ref.onClose,
      className = _ref.className,
      _ref$noScroll = _ref.noScroll,
      noScroll = _ref$noScroll === void 0 ? true : _ref$noScroll,
      _ref$fullscreen = _ref.fullscreen,
      fullscreen = _ref$fullscreen === void 0 ? false : _ref$fullscreen;
  var appElement;

  if (document.body) {
    appElement = document.body.querySelector(".site-wrapper") || undefined;
  }

  useEffect(function () {
    if (noScroll) {
      document.body.classList.toggle("no-scroll", isOpen);
      return function () {
        document.body.classList.remove("no-scroll");
      };
    }
  }, [isOpen, noScroll]);
  return React.createElement(Modal, {
    appElement: appElement,
    className: classnames(styles.modal, className, _defineProperty({}, styles.fullscreen, fullscreen)),
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onRequestClose: onClose,
    overlayClassName: styles.overlay
  }, React.createElement("div", {
    className: styles.closeContainer
  }, React.createElement(CloseButton, {
    onClick: onClose
  })), children);
}

export default GenericModal;